"use client";
import { useEffect, useState } from "react";
import { Table, message, Button, Modal, Popconfirm } from "antd";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { DeleteOutlined, EditOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import AddUserModal from "./add";
import EditUserModal from "./edit";

const { confirm } = Modal;

const UserManagementList = () => {
  const [pageLoader, setPageLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const currentUserRole = "Super Admin"; // Change to "Admin" for testing

  const getUserList = async () => {
    setPageLoader(true);
    try {
      const formData = new FormData();
      const res = await post(ApiURL.list_user, formData);
      if (res?.status) {
        setFilteredData(res.data);
      } else {
        message.error(res?.message || "Failed to fetch user list");
      }
    } catch (error) {
      message.error("Something went wrong while fetching users");
    } finally {
      setPageLoader(false);
    }
  };

  useEffect(() => {
    getUserList();
  }, []);

  const handleEditUser = (record) => {
    setSelectedUserId(record.id || record.user_id);
    setOpenEditModal(true);
  };

  const handleAddUser = () => {
    setOpenAddModal(true);
  };

const handleDeleteUser = async (record) => {
  try {
    const userId = record.id || record.user_id;

    if (!userId) {
      message.error("User ID not found");
      return;
    }

    const formData = new FormData();
    formData.append("user_id", userId);

    const res = await post(ApiURL.delete_user, formData);

    if (res?.status) {
      message.success(res?.message || "User deleted successfully");
      getUserList();
    } else {
      message.error(res?.message || "Failed to delete user");
    }
  } catch (error) {
    message.error("Error while deleting user");
  }
};

  const columns = [
    { title: "Name", dataIndex: "name", key: "name", align: "center" },
    { title: "Email", dataIndex: "email", key: "email", align: "center" },
    { title: "Role", dataIndex: "role", key: "role", align: "center" },
    { title: "Phone Number", dataIndex: "phone_number", key: "phone_number", align: "center", render: (text) => text && text.trim() !== "" ? text : "-",},
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => (text ? new Date(text).toLocaleString() : "-"),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      align: "center",
      render: (text) => (text ? new Date(text).toLocaleString() : "-"),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) =>
        currentUserRole === "Super Admin" ? (
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <Button
              onClick={() => handleEditUser(record)}
              icon={<EditOutlined />}
              style={{
                backgroundColor: "#E11236",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
              }}
            />
            {/* <Button
              onClick={() => handleDeleteUser(record)}
              icon={<DeleteOutlined />}
              style={{
                backgroundColor: "#E11236",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
              }}
            /> */}
            <Popconfirm
  title="Delete Staff"
  description={`Are you sure you want to delete "${record.name}"?`}
  okText="Yes"
  cancelText="No"
  okButtonProps={{ danger: true }}
  onConfirm={() => handleDeleteUser(record)}
>
  <Button
    icon={<DeleteOutlined />}
    style={{
      backgroundColor: "#E11236",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
    }}
  />
</Popconfirm>
          </div>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <div style={{ padding: "10px" }}>
      <div
        className="flex justify-between items-center mb-3"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", }}
      >
        <h3>User Management</h3>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAddUser}
          style={{ backgroundColor: "#E11236", border: "none" }}
        >
          Add User
        </Button>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey={(record) => record.id || record.user_id}
        loading={pageLoader}
      />

      {openAddModal && (
        <AddUserModal
          open={openAddModal}
          onCancel={() => setOpenAddModal(false)}
          onSuccess={getUserList}
        />
      )}

      {openEditModal && (
        <EditUserModal
          open={openEditModal}
          onCancel={() => {
            setOpenEditModal(false);
            setSelectedUserId(null);
          }}
          onSuccess={getUserList}
          userId={selectedUserId}
        />
      )}
    </div>
  );
};

export default UserManagementList;
